module.exports = __webpack_public_path__ + "img/icons8-shopping-bag-96.b6c32df1.png";